import { Container, ContainerProps } from "@mui/material";
import { ReactNode, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

interface FadeContainerProps extends Omit<ContainerProps, 'component'> {
    children: ReactNode;
    component?: React.ElementType;
}

export const FadeContainer = ({ children, component = "main", sx, ...props }: FadeContainerProps) => {
    const location = useLocation();
    const [isVisible, setIsVisible] = useState(true);
    const [displayChildren, setDisplayChildren] = useState(children);

    useEffect(() => {
        // When location changes, start fade out
        //setIsVisible(false);
        
        // After fade out completes, update content and fade in
        //const timer = setTimeout(() => {
        //    setDisplayChildren(children);
        //    setIsVisible(true);
        //}, 150); // Half of the transition duration

        //return () => clearTimeout(timer);
    }, [location.pathname, children]);

    return (
        <Container 
            component={component}
            sx={{ 
                opacity: isVisible ? 1 : 0,
                transition: 'opacity 0.3s ease-in-out',
                ...sx
            }}
            {...props}
        >
            {displayChildren}
        </Container>
    );
}; 